import classNames from "classnames";
import * as React from "react";
import styles from "../index.module.css";
import type { CustomArrowProps } from "react-slick";

export const NextArrow: React.FC<CustomArrowProps> = ({
  onClick,
  currentSlide,
  slideCount,
}) => {
  const disabled =
    typeof currentSlide === "undefined" ||
    typeof slideCount === "undefined" ||
    currentSlide === slideCount - 2;

  return (
    <div
      className={classNames(styles.slideArrow, styles.slideArrowNext, {
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
    >
      <img src="/img/slider_arrow_bold.svg" alt="" />
    </div>
  );
};
